import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { getAdminAppeals, getOrderAndAppeals, updateOrderStatus, updateOrderSum } from "./slice";
import { AdminAppealRequest, AdminAppealUpdateStatusRequest, AdminAppealUpdateSumRequest } from "./api";

export const useAdminAppeals = () => {
  const state = useAppSelector((state) => state.adminAppeals);
  const dispatch = useAppDispatch();

  const getAdminAppealsHandler = useCallback(
    (data?: AdminAppealRequest) => dispatch(getAdminAppeals({ data })),
    [dispatch]
  );

  const updateOrderSumHandler = useCallback(
    (order_uuid: string, data: AdminAppealUpdateSumRequest) =>
      dispatch(updateOrderSum({ order_uuid, data })),
    [dispatch]
  );

  const updateOrderStatusHandler = useCallback(
    (appeal_id: string, data: AdminAppealUpdateStatusRequest) =>
      dispatch(updateOrderStatus({ appeal_id, data })),
    [dispatch]
  );

  const getOrderAndAppealsHandler = useCallback(
    (order_id: string) =>
      dispatch(getOrderAndAppeals({ order_id })),
    [dispatch]
  );

  return {
    state,
    getAdminAppeals: getAdminAppealsHandler,
    updateOrderSum: updateOrderSumHandler,
    updateOrderStatus: updateOrderStatusHandler,
    getOrderAndAppeals: getOrderAndAppealsHandler,
  };
};
